/* eslint-disable @typescript-eslint/strict-boolean-expressions */
export const getCurrentLocationUUID = (): any => {
  const node: any = document.querySelector('#currentLocationUuid');
  if (node) {
    return node.dataset.uuid;
  }
  return null;
};
